export const COHORTS_FETCH: string = 'COHORTS_FETCH'
export const COHORTS_FETCH_REQUESTING: string = 'COHORTS_FETCH_REQUESTING'
export const COHORTS_FETCH_ERROR: string = 'COHORTS_FETCH_ERROR'
export const COHORTS_FETCH_SUCCESS: string = 'COHORTS_FETCH_SUCCESS'

export const COHORT_PROGRESS: string = 'COHORT_PROGRESS'
